<template>
  <div
    class="c-outage-result__planned"
    :class="{
      'c-outage-result__planned--list-view': outagePageView === 'list',
    }"
  >
    <div
      class="c-outage-result__planned-triangle"
      :class="{
        'c-outage-result__planned-triangle--cancelled':
          outage.status == 'Cancelled',
      }"
    ></div>
    <div class="c-outage-result__wrapper">
      <img class="c-outage-result__graphic" :src="getMarkerIcon(outage)" />
      <div class="c-outage-result__details">
        <p class="c-outage-result__outage-number">
          {{ "#" + outage.distributorEventNumber }}
        </p>
        <h3 class="c-outage-result__outage-title">
          <a :href="outage.link">
            {{ outage.suburbsText }}
          </a>
        </h3>

        <p class="c-outage-result__outage-type">
          <span v-if="outage.status != 'Cancelled'">Planned outage</span>
          <span v-else class="c-outage-result__outage-type-cancelled"
            >Planned outage</span
          >
          <span
            v-if="outage.status == 'Cancelled'"
            class="c-outage-result__outage-cancelled"
            >Cancelled</span
          >
          <span
            v-if="outage.useAlternateDate"
            class="c-outage-result__outage-alternate-date-wrapper"
          >
            <span
              class="c-outage-result__outage-alternate-date"
              :class="{
                'c-outage-result__outage-alternate-date--strike':
                  outage.status == 'Cancelled',
              }"
              >Alternative date in use</span
            >
            <outage-tooltip
              :tooltip-content="cmsContent.alternateDateContent"
              class="c-outages-nav__filter-tooltip"
            ></outage-tooltip>
          </span>
        </p>

        <div class="c-outage-result__details-holder">
          <div class="c-outage-result__details-times">
            <template v-if="outage.useAlternateDate">
              <p
                class="c-outage-result__start-time"
                :class="{
                  'c-outage-result__start-time--cancelled':
                    outage.status == 'Cancelled',
                }"
              >
                New scheduled start date/time:
                <span class="c-outage-result__bold">{{
                  formatDate(outage.alternateStartDateTime)
                }}</span>
              </p>
              <p
                class="c-outage-result__end-time"
                :class="{
                  'c-outage-result__end-time--cancelled':
                    outage.status == 'Cancelled',
                }"
              >
                New scheduled end date/time:
                <span class="c-outage-result__bold">{{
                  formatDate(outage.alternateEndDateTime)
                }}</span>
              </p>
            </template>
            <template v-else>
              <p
                class="c-outage-result__start-time"
                :class="{
                  'c-outage-result__start-time--cancelled':
                    outage.status == 'Cancelled',
                }"
              >
                Scheduled start date/time:
                <span class="c-outage-result__bold">{{
                  formatDate(outage.outageStartDateTime)
                }}</span>
              </p>
              <p
                class="c-outage-result__end-time"
                :class="{
                  'c-outage-result__end-time--cancelled':
                    outage.status == 'Cancelled',
                }"
              >
                Scheduled end date/time:
                <span class="c-outage-result__bold">{{
                  formatDate(outage.outageEndDateTime)
                }}</span>
              </p>
              <p
                class="c-outage-result__alternate-date"
                v-if="outage.alternateDate"
                :class="{
                  'c-outage-result__alternate-date--cancelled':
                    outage.status == 'Cancelled',
                }"
              >
                Alternative date:
                <span class="c-outage-result__bold">
                  {{ formatDate(outage.alternateDate, false) }}
                </span>
              </p>
            </template>
          </div>
          <div class="c-outage-result__additional-details">
            <div v-if="outagePageView === 'list'">
              <p class="">
                Customers affected:
                <span class="c-outage-result__bold">{{
                  outage.customersAffected
                }}</span>
              </p>
              <p class="">
                Reason for outage:
                <span class="c-outage-result__bold">{{
                  outage.reasonForOutage
                }}</span>
              </p>
              <p v-if="outage.status == 'Cancelled'" class="">
                Reason for cancellation:
                <span
                  v-if="outage.reasonForCancellation"
                  class="c-outage-result__bold"
                  >{{ outage.reasonForCancellation | capitalize }}</span
                >
                <span v-else class="c-outage-result__bold">{{
                  cmsContent.defaultReasonForCancellation | capitalize 
                }}</span>
              </p>
            </div>
          </div>
        </div>

        <a :href="outage.link" class="c-outage-result__link"
          >More details<span>
            <img
              :src="'_resources/app/client/assets/icons/outages-map/more-details-arrow.svg'"
            /> </span
        ></a>

        <span
          v-if="outagePageView == 'map'"
          @click="zoomToMap(outage)"
          class="c-outage-result__zoom"
        >
          <img :src="'_resources/app/client/assets/icons/outages-map/map-icon.svg'" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import { eventBus } from "../utils/event-bus.js";
import OutageTooltip from "./OutageTooltip.vue";

export default {
  props: {
    outage: Object,
  },
  created() {},
  components: {
    OutageTooltip,
  },
  mounted() {},
  computed: {
    ...mapFields(["filterOption", "outagePageView", "cmsContent"]),
    ...mapGetters(["getMarkerIcon"]),
  },
  methods: {
    zoomToMap(outage) {
      eventBus.$emit("gmap-pan-to", outage.location);
    },
  },
};
</script>

<style lang="scss"></style>
